export abstract class BaseObject extends Object {

    convertToNumber = (t: string | number): number => {
        if (typeof t === 'string') {
            t = t.replace(',', '.');
            return +t;
        }

        return t;
    };
}



// WEBPACK FOOTER //
// /app/src/model/Entities/BaseObject.ts